package one.primehealth.app

actual fun targetPlatform(): TargetPlatform = TargetPlatform.Web